/* PREMIUMS ACCOUNTS */
export const GET_PREMIUMS_ACCOUNTS = "GET_PREMIUMS_ACCOUNTS";
export const GET_PREMIUMS_ACCOUNTS_SUCCESS = "GET_PREMIUMS_ACCOUNTS_SUCCESS";
export const GET_PREMIUMS_ACCOUNTS_FAIL = "GET_PREMIUMS_ACCOUNTS_FAIL";

export const SET_SELECTED_PA = "SET_SELECTED_PA";
